import { Helmet } from 'react-helmet-async';
import { useSiteSettings } from '../context/SiteSettingsContext';

const getAbsoluteUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${url.startsWith('/') ? '' : '/'}${url}`;
};

export default function SiteMeta({ title, description, image, type = 'website' }) {
  const { shareThumbnail, siteIcon } = useSiteSettings();
  const defaultIcon = siteIcon || '/favicon.png';
  const ogImageRaw = image || shareThumbnail || defaultIcon;
  const ogImage = getAbsoluteUrl(ogImageRaw);
  const icon = getAbsoluteUrl(defaultIcon);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      {ogImage && <meta property="og:image:secure_url" content={ogImage} />}
      <meta name="twitter:card" content={image || shareThumbnail ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {icon && <link rel="icon" href={icon} />}
      {icon && <link rel="apple-touch-icon" href={icon} />}
    </Helmet>
  );
}
